import { useDateTime } from '@ai/ui-components'
import { createLivekitContextEngine } from './createLivekitContextEngine'

let sharedEngine: ReturnType<typeof createLivekitContextEngine> | null = null

/**
 * Returns the shared livekit context singleton used by reactive UI consumers.
 *
 * This wrapper shares state across the app, so it is the right choice for modals
 * and live supervision flows. Do not use it for isolated one-off work such as
 * export building; create a dedicated engine with `createLivekitContextEngine()`.
 */
export const useLivekitContext = () => {
  const formatter = useDateTime()
  sharedEngine ??= createLivekitContextEngine(formatter)
  return sharedEngine
}
